import { motion } from 'framer-motion';
import { type ReactNode, useState } from 'react';
import { cn } from '../../lib/utils';
import { pageEnter } from './motion';

interface PortalPageProps {
  children: ReactNode;
  className?: string;
  /** Widest content column in the Figma pages is 1304px inside 64px gutters. */
  contentClassName?: string;
}

// Path of the last PortalPage that played `pageEnter`; a skeleton → content
// swap on the same route remounts the page and must not replay it.
let lastEnteredPath: string | null = null;

/**
 * Scroll container + centered content column shared by every redesigned
 * dashboard page (Overview, Releases, Store Listing, Ratings & Reviews…).
 * The content column rises in (`pageEnter`, 200ms) once per route visit.
 */
export function PortalPage({
  children,
  className,
  contentClassName,
}: PortalPageProps) {
  const [shouldEnter] = useState(() => {
    const path =
      typeof window === 'undefined' ? null : window.location.pathname;
    const enter = path !== lastEnteredPath;
    lastEnteredPath = path;
    return enter;
  });

  return (
    <div className={cn('flex h-full flex-col overflow-y-auto', className)}>
      <motion.div
        {...(shouldEnter ? pageEnter : {})}
        className={cn(
          'mx-auto flex w-full max-w-[1432px] flex-1 flex-col gap-10 px-5 py-8 sm:px-8 lg:px-16 lg:py-16',
          contentClassName,
        )}
      >
        {children}
      </motion.div>
    </div>
  );
}
